/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 1 = Active
 *
 * 2 = Overdue
 *
 * 3 = Completed
 */
export enum NextContactStatus {
  Active = 1,
  Overdue = 2,
  Completed = 3,
}
